module.exports = __webpack_public_path__ + "static/media/home-carte.06ff2207.jpg";